// Login.js
import React, { Component } from "react";
import "./Login.css";
import "@assets/Feelmehome.css";
import { fetcher } from "../components/utility";
import { Trans, t } from "@lingui/macro";
import * as Sentry from "@sentry/react";

class RecoverPass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mail: "",
      success: "null",
    };
  }
  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.recover();
    }
  };

  recover = () => {
    const mail = this.state.mail;
    fetcher({ path: "/api/forgot", method: "POST", body: { mail } })
      .then((res) => {
        if (!res.success) {
          this.setState({ success: "fail" });
        } else {
          this.setState({ success: "success" });
        }
      })
      .catch((e) => Sentry.captureException(e));
  };

  checkMailState = (event) => {
    this.setState({ mail: event.target.value });
  };

  render() {
    return (
      <div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-9 flex-grow-1">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <div className="thipi-text-h2 text-center">
                    {this.state.success === "null"
                      ? t`Inserisci la tua mail di registrazione `
                      : this.state.success === "fail"
                      ? t`Mail non trovata`
                      : t`Ti abbiamo inviato un'email per il ripristino 🔒`}
                  </div>
                </div>
                <div className="panel-body">
                  {this.state.success !== "success" && (
                    <form acceptCharset="UTF-8">
                      <div className="form-group">
                        <input
                          className="form-control"
                          placeholder={t`E-mail`}
                          name="email"
                          type="text"
                          autoComplete="email"
                          value={this.state.mail}
                          onChange={this.checkMailState}
                          onKeyPress={this.handleKeyPress}
                          /*required*/ autoFocus
                        />
                      </div>
                      <button
                        className="btn btn-lg btn-mycolor btn-block"
                        type="button"
                        onClick={() => {
                          this.recover();
                        }}
                      >
                        <Trans>Recupera Password</Trans>
                      </button>
                    </form>
                  )}
                  {this.state.success === "success" && (
                    <div className="text-center pt-3">
                      <div
                        className="thipi-text-h5 mb-3"
                        style={{ opacity: 0.8 }}
                      >
                        <Trans>
                          Se non la trovi in arrivo entro qualche minuto, controlla anche le cartelle Spam o Promozioni.
                        </Trans>
                      </div>
                      <button
                        className="btn"
                        type="button"
                        style={{ color: "#ff7417" }}
                        onClick={() => {
                          this.setState({ success: "null" });
                        }}
                      >
                        <Trans>Non hai ricevuto la mail? Reinviala</Trans>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RecoverPass;
